var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from 'react';
import { Text } from 'react-native';
export function createIconSet(config, fontFamilyArg, fontFile) {
    var _a;
    const glyphMap = {};
    (_a = config.glyphs) === null || _a === void 0 ? void 0 : _a.forEach(glyph => {
        if (glyph.css) {
            glyphMap[glyph.css] = glyph.code;
        }
    });
    const fontFamily = fontFamilyArg || config.name || 'fontello';
    if (!fontFile) {
        fontFile = `${fontFamily}.ttf`;
    }
    const fontBasename = fontFile
        ? fontFile.replace(/\.(otf|ttf)$/, '')
        : fontFamily;
    const fontReference = fontBasename;
    return class Icon extends PureComponent {
        render() {
            const _a = this.props, { name, size = 12, color, style, children } = _a, props = __rest(_a, ["name", "size", "color", "style", "children"]);
            let glyph = name ? glyphMap[name] || '?' : '';
            if (typeof glyph === 'number') {
                glyph = String.fromCodePoint(glyph);
            }
            props.style = [
                { fontSize: size, color },
                style,
                { fontFamily: fontReference, fontWeight: 'normal', fontStyle: 'normal' }
            ];
            return (_jsxs(Text, Object.assign({ selectable: false }, props, { children: [glyph, children] })));
        }
    };
}
